export default {
	init() {
		const checkbox = document.querySelector('.js-product-disclaimer');
		const addToCard = document.querySelector('.js-add-to-cart');

		checkbox.addEventListener('change', function() {
			if(this.checked) {
				addToCard.classList.remove('t-hidden-visible');
			} else {
				addToCard.classList.add('t-hidden-visible');
			}
		});
	}
}